import { useContext } from 'react';
import PropTypes from 'prop-types';
import { ContextApp } from '../../context';
import MoviesList from '../movies-list';

const FavoritesMoviesListContainer = ({showFavoritesMovies, showFavoritesPremieres}) => {
    const { state: { favoritesMovies, favoritesPremieres } } = useContext(ContextApp);

    if (showFavoritesMovies) {
        return (favoritesMovies.length) ? <MoviesList movies={favoritesMovies}/> : <div>Вы ничего не добавляли в избранное</div>
    } else if (showFavoritesPremieres) {
        return (favoritesPremieres.length) ? <MoviesList movies={favoritesPremieres}/> : <div>Вы не отслеживаете ни одной премьеры</div>
    }
};

FavoritesMoviesListContainer.propTypes = {
    showFavoritesMovies: PropTypes.bool.isRequired,
    showFavoritesPremieres: PropTypes.bool.isRequired,
};

export default FavoritesMoviesListContainer;